import { makeStyles } from "../Utilities/ThemeHelper";
export const useStyles = makeStyles(() => ({
  root: {
    cursor: props => props.onClick ? "pointer" : undefined,
    display: props => props.block ? "block" : undefined
  }
}));